import {FC, useEffect, useRef, useState} from 'react'
import {Dropdown} from 'react-bootstrap'
import MoreButton from '_core/components/MoreButton'
import storeService from 'app/services/StoreService/StoreService'
import ReactToPrint, {PrintContextConsumer} from 'react-to-print'
import {PackageSlip} from '../../fulfillments/components'
import PrintShippingLabel from '../../fulfillments/fulfillment/components/PrintShippingLabel'
import {KTSVG} from '_metronic/helpers'

interface Props {
  order: any
  fulfillment?: any
  isPos?: boolean
  handleOpenLocationDialog?: any
}

export const PrintOrder: FC<Props> = ({order, fulfillment, isPos, handleOpenLocationDialog}) => {
  const componentRef = useRef(null)
  const [store, setStore] = useState<any>(null)
  const [shippingLabel, setShippingLabel] = useState<any>()

  useEffect(() => {
    if (fulfillment) {
      const {
        fulfillmentShippingLabels: {nodes: fulfillmentShippingLabels},
      } = fulfillment
      const shippingLabel =
        fulfillmentShippingLabels.length > 0 ? fulfillmentShippingLabels[0] : null
      setShippingLabel(shippingLabel)
    }
  }, [fulfillment])

  useEffect(() => {
    const fetch = async () => {
      const store = await storeService.store()
      setStore(store)
    }

    fetch()
  }, [])

  if (!store) {
    return null
  }

  return (
    <MoreButton>
      <Dropdown.Item eventKey='1'>
        <div>
          <ReactToPrint
            content={() => componentRef.current}
            documentTitle={`order_${order.orderNumber}`}
          >
            <PrintContextConsumer>
              {({handlePrint}) => (
                <div onClick={handlePrint} className='text-hover-primary'>
                  Print packing slip
                </div>
              )}
            </PrintContextConsumer>
          </ReactToPrint>
          <div className='d-none'>
            {isPos ? (
              <PackageSlip
                ref={componentRef}
                fulfillment={mapToSetFulfillment(order)}
                store={store}
                order={order}
              />
            ) : (
              <PackageSlip
                ref={componentRef}
                fulfillment={fulfillment}
                store={store}
                order={order}
              />
            )}
          </div>
        </div>
      </Dropdown.Item>
      {shippingLabel && (
        <Dropdown.Item eventKey='2'>
          <PrintShippingLabel shippingLabel={shippingLabel} />
        </Dropdown.Item>
      )}
      {fulfillment && fulfillment.id && !isPos && (
        <Dropdown.Item
          onClick={() =>
            handleOpenLocationDialog({
              id: fulfillment.id,
              locationId: fulfillment.locationId,
            })
          }
        >
          <KTSVG path='/media/icons/corksy/location.svg' className='svg-icon-muted svg-icon-x' />
          Change Inventory Location
        </Dropdown.Item>
      )}
    </MoreButton>
  )
}

export default PrintOrder

const mapToSetFulfillment = (order: any) => {
  const fulfillment = {
    fulfillmentItems: {nodes: mapToPosOrderItemsModel(order.orderItems)},
  }
  return fulfillment
}

const mapToPosOrderItemsModel = (items: any[]) => {
  return items.map((item: any) => {
    return {
      ...item,
      price: item.price,
      quantity: item.quantity,
      variant: item.variant,
      orderedQuantity: item.quantity,
    }
  })
}
